import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import { CodeBlock, BlockType, SettingType } from '@appblocks/codegeneration/types';

export default class Tibbit_42 extends BaseTibbit {
    constructor() {
        super();
        this.id = 'tibbit_42';
        this.name = 'Tibbit 42';
        this.fileLinks = [
            // 'ssi\\ssi.tbs',
            // 'ssi\\ssi.tbh',
        ];
        this.files = [
            'libraries/super_i2c/super_i2c.tbh',
            'libraries/super_i2c/super_i2c.tbs',
            'libraries/super_spi/super_spi.tbh',
            'libraries/super_spi/super_spi.tbs',
            'libraries/tibbits/tbt42/tbt42.tbh',
            'libraries/tibbits/tbt42/tbt42.tbs',
            'libraries/ssi/ssi.tbh',
            'libraries/ssi/ssi.tbs',
        ];
        const settings = [
            {
                id: 'NAME',
                name: 'Name',
                settingType: SettingType.NAME,
                required: true,
                default: '',
            },
            {
                id: 'USESSI',
                name: 'Mode',
                settingType: SettingType.OPTION,
                required: true,
                default: 'YES',
                options: [
                    {
                        name: 'I2C mode',
                        value: 'YES',
                    },
                    {
                        name: 'Direct I/O (bit-banging)',
                        value: 'NO',
                    },
                ],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks() {
        const blocks: Array<CodeBlock> = [];

        if (this.project.runtime === 'simulator') {
            return [];
        }

        const socket = Tibbits.getSocket(this.getSettingValue('SOCKET'), this.project.device.id);

        blocks.push({
            location: 'boot',
            blockType: BlockType.CODE,
            template: `
    'Tibbit 42 on socket ${this.getSettingValue('SOCKET')}
    '================================================================
    select case tbt42_init(YES,${this.getSettingValue('NAME')}_CS,${this.getSettingValue('NAME')}_CLK,${this.getSettingValue('NAME')}_MOSI,${this.getSettingValue('NAME')}_MISO,${this.getSettingValue('NAME')}_CHANNEL)
    case TBT42_SELF_TEST_FAIL:
        sys.debugprint("Self test fail for the RTC Backup module (#42).\\r\\n")

    case TBT42_NO_SSI_AVAILABLE:
        sys.debugprint("SSI channel could not be allocated for the RTC Backup module (#42), using bit banging instead.\\r\\n")
    end select
    'Code sample at: https://github.com/tibbotech/CA-Test-Tibbit-42
    
    'Include the following lines of code to display the current date and time from the from the Tibbit 42 RTC.
    
    'dim dayc,minc as word
    'dim sec as byte
    'tbt42_rtc_get(dayc,minc,sec,TBT42_S11_CS,TBT42_S11_CHANNEL)
    'sys.debugprint("Current date and time: "+str(2000+year(dayc))+"-"+str(month(dayc))+"-"+str(date(dayc))+" "+str(hours(minc))+":"+str(minutes(minc))+":"+str(sec)+"\\r\\n")

    '-----------------------------------------------------------------
        `,
        });

        blocks.push({
            location: 'GLOBAL_DECLARATIONS',
            blockType: BlockType.CODE,
            template: `
declare ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_DIMS',
            blockType: BlockType.CODE,
            template: `
dim ${this.getSettingValue('NAME')}_CHANNEL as byte`,
        });

        blocks.push({
            location: 'GLOBAL_CONSTS',
            blockType: BlockType.CODE,
            template: `
const ${this.getSettingValue('NAME')}_CS=${socket?.pins[0]}
const ${this.getSettingValue('NAME')}_CLK=${socket?.pins[1]}
const ${this.getSettingValue('NAME')}_MOSI=${socket?.pins[2]}
const ${this.getSettingValue('NAME')}_MISO=${socket?.pins[3]}`,
        });


        return blocks;
    }
}
